require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-guessing-rohr-im-burgenland.json") })
        }
      }, "path---betreuungseinrichtungen-guessing-rohr-im-burgenland");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-guessing-rohr-im-burgenland!./.cache/json/betreuungseinrichtungen-guessing-rohr-im-burgenland.json
// module id = 901
// module chunks = 231608221292675